export default __webpack_public_path__ + "static/media/project-status-pending-bond.49ea4ec0.svg";